import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from 'recharts';

function ChartMeioPagamento({ countMeio = {} }) {
    const data = [
        { name: 'PIX', valor: Number(countMeio?.pix) || 0 },
        { name: 'CARTÃO', valor: Number(countMeio?.cartao) || 0 },
        { name: 'BOLETO', valor: Number(countMeio?.boleto) || 0 },
        { name: 'CORTESIA', valor: Number(countMeio?.cortesia) || 0 }
    ];

    return (
        <div className="w-full h-64">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#262B34" vertical={false} />
                    <XAxis dataKey="name" stroke="#94A3B8" fontSize={12} tickLine={false} />
                    <YAxis stroke="#94A3B8" fontSize={12} tickLine={false} allowDecimals={false} />
                    <Tooltip
                        contentStyle={{ backgroundColor: '#111317', borderColor: '#262B34', borderRadius: '8px', color: '#fff' }}
                        cursor={{ fill: 'rgba(138, 230, 0, 0.05)' }}
                    />
                    <Bar dataKey="valor" fill="#8AE600" radius={[6, 6, 0, 0]}>
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill="#8AE600" />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export default ChartMeioPagamento;